import { render, staticRenderFns } from "./MyNav.vue?vue&type=template&id=4aaf0a28&scoped=true&"
import script from "./MyNav.vue?vue&type=script&lang=js&"
export * from "./MyNav.vue?vue&type=script&lang=js&"
import style0 from "./MyNav.vue?vue&type=style&index=0&id=4aaf0a28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf0a28",
  null
  
)

export default component.exports